import React from "react";
import GetAppRoundedIcon from "@material-ui/icons/GetAppRounded";
import IconButton from "@material-ui/core/IconButton";
import styles from "./generatepdf.module.css";
import alderLogo from "../../../assets/img/alder-logo.png";
import { Tooltip } from "@material-ui/core";
import { renderToString } from "react-dom/server";
import jsPDF from "jspdf";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
  },
}));
const GeneratePdf = (props) => {
  const classes = useStyles();
  console.log("Generate PDF Page");
  const InvoiceHtml = () => {
    console.log("props.order.allLoad");
    console.log(props.order.allLoad);
    console.table(props.order.allLoad);
    let totalAmount = 0;
    let products = [];
    let pushedObjects = [];
    let orderToDetails =
    props.order.orderType == "sales"
      ? props.order.partner
      : props.order.warehouse;
    let orderToName = orderToDetails?.name;
    let totalGrossWeight = 0;
    let totalPkg = 0;
    let totalOrderQty = 0;
    let orderDate = props.order.orderDate;
    let datearray = orderDate.split("-");
    let newDate = datearray[2] + '-' + datearray[1] + '-' + datearray[0];
    orderDate = newDate;
    // let orderItems = [];
    // orderItems = [...props.order.allLoad];
    let orderItems = props.order.allLoad.map((item) => {
      return { ...item };
    });
    console.table(orderItems);
    orderItems.forEach((val) => {
      if (val.quantity > 1) {
        // this is just a temporary solution
        // for the issue of automatically change of quantity value in props.order.allLoad
        console.log("excel val.quantity");
        console.log(val.quantity);
        val.quantity = 1;
        console.log(val.quantity);
      }
      // let temp =
      //   val.price * val.quantity +
      //   (val.tax.gst / 100) * val.price * val.quantity;
      // totalAmount += temp - (temp / 100) * val.discount;
      let ecomPrice = Math.floor(val.price*1.18);
      ecomPrice = ecomPrice*val.quantity;
      totalAmount += ecomPrice;
      let productId = val.item._id;
      console.log("productId exist:" + productId);
      if (pushedObjects.length > 0 && pushedObjects.includes(productId)) {
        console.log("id exist");
        var productIndex = products.findIndex(function (value) {
          return value.item._id == productId;
        });
        console.log(products);
        console.log("product index:" + productIndex);
        let currentQuantity = 0;
        currentQuantity = products[productIndex].quantity;
        console.log("product index quantity:" + currentQuantity);
        products[productIndex].quantity = currentQuantity + 1;
        console.log(
          "product index after quantity:" + products[productIndex].quantity
        );
      } else {
        console.log("id not exist");
        pushedObjects.push(productId);
        products.push(val);
      }
      // }
    });
    totalAmount = totalAmount.toFixed(2);
    console.table(products);
    console.log(pushedObjects);
    return (
      <React.Fragment>
        <div className={styles.container}>
          <div className={styles.content}>
            <div className={styles.header}>
              <img src={alderLogo} alt="alder logo" />
              <div className={styles.contentright}>
                <h3>Alder Furniture Pvt Ltd</h3>
                <h3>
                  27 Furniture Block, Kirti&nbsp;Nagar, New Delhi – 110015, INDIA
                </h3>
                <h3>
                  Website: www.alder.in, Email: info@alder.in | sales@alder.in
                </h3>
                <h3>Phone: +91-011-42903322</h3>
              </div>
            </div>
            <div className={styles.center}>
              <p>ESTIMATED</p>
            </div>

            <div className={styles.divider}>
              <p>Estimate&nbsp;No:{props.order.order_barcode}</p>
              <p>Dispatch&nbsp;Date:{orderDate}</p>
            </div>

            <div className={styles.alignStart}>
              {/* <p>CLIENT ID: 12121</p> */}
              <p>Client&nbsp;Name:<span className={styles.clientName}>{orderToName.toLowerCase()}</span></p>
              {/* <p>Order Id: {props.order._id}</p>
              <p>Order Barcode: {props.order.order_barcode}</p> */}
            </div>

            <table className={styles.table} border="1">
              <tr className={styles.tableHeader}>
              <th>Sl No</th>
                <th>Item Code</th>
                <th>Item Name</th>
                <th>Order Qty</th>
                <th>Packages (parts)</th>
                <th>Total pkg</th>
                <th>Total weight</th>
                {/* <th>Total CBM</th> */}
                <th>Unit Price(INR)</th>
                <th>Discount(%)</th>
                <th>Tax(%)</th>
                <th>Total Amount(INR)</th>
              </tr>
              {products.map((val, index) => {
                let totalWeight = 0;
                let totalCBM = 0;
                val.type == "Product" &&
                  val.item &&
                  val.item.productParts.map((part) => {
                    totalWeight += parseInt(part.partId && part.partId.weight);
                    totalCBM +=
                      part.partId &&
                      part.partId.height * part.partId &&
                      part.partId.width * part.partId &&
                      part.partId.length;
                  });
                // let totalAmount =
                //   val.price * val.quantity +
                //   (val.tax.gst / 100) * val.price * val.quantity;
                let totalAmount = Math.floor(val.price*1.18);
                totalAmount = totalAmount*val.quantity;
                let totalAmountDis =
                  totalAmount - (totalAmount / 100) * val.discount;
                  totalGrossWeight += totalWeight * val.quantity;
                totalOrderQty += val.quantity;
                totalPkg += val.type== "Product" && val.item  ?
                val.item.productParts.length*val.quantity:1*val.quantity;
                return (
                  <React.Fragment>
                    {val.type == "Product" && val.item && val.item != null ? (
                      <tr>
                        <td>{index + 1}</td>
                        <td>{val.item && val.item.product_barcode}</td>
                        <td>{val.item && val.item.productName}</td>
                        <td>{val.quantity}</td>
                        <td>{val.item && val.item.productParts.length}</td>
                        <td>
                          {val.item &&
                            val.item.productParts.length * val.quantity}
                        </td>
                        <td>
                          {totalWeight > 0 ? totalWeight * val.quantity : ""}
                        </td>
                        {/* <td>{totalCBM > 0 ? totalCBM * val.quantity : ""}</td> */}
                        <td>{val.price}</td>
                        <td>{val.discount} %</td>
                        <td>{val.tax.gst}%</td>
                        <td>{totalAmountDis}</td>
                      </tr>
                    ) : (
                      <tr>
                        <td>{index + 1}</td>
                        <td>{val.item && val.item.parts_barcode}</td>
                        <td>{val.item && val.item.partName}</td>
                        <td>{val.quantity}</td>
                        <td>1</td>
                        <td>{val.quantity}</td>
                        <td>
                          {val.item && val.item.weight > 0
                            ? val.item.weight * val.quantity
                            : ""}
                        </td>
                        {/* <td>
                          {val.item &&
                          val.item.height * val.item.width * val.item.length > 0
                            ? val.item.height *
                              val.item.width *
                              val.item.length *
                              val.quantity
                            : ""}
                        </td> */}
                        <td>{val.price}</td>
                        <td>{val.discount} %</td>
                        <td>{val.tax.gst} %</td>
                        <td>{totalAmountDis}</td>
                      </tr>
                    )}
                  </React.Fragment>
                );
              })}
              <tr className={styles.footerRow}>
                <th colSpan="3" className={styles.footer}>
                  Total Qty
                </th>
                <th colSpan="1" className={styles.footer}>
                  {totalOrderQty}
                </th>
                <th colSpan="1" className={styles.footer}>
                </th>
                <th colSpan="1" className={styles.footer}>
                  {totalPkg}
                </th>
                <th colSpan="1" className={styles.footer}>
                  {totalGrossWeight}
                </th>
                <th colSpan="3" className={styles.footer}>
                  Total Amount
                </th>
                <th colSpan="1" className={styles.footer}>
                  Rs {totalAmount}
                </th>
              </tr>
            </table>
          </div>
        </div>
      </React.Fragment>
    );
  };
  const print = () => {
    const htmlString = renderToString(<InvoiceHtml />);
    console.log("htmlString");
    console.log(htmlString);
    const pdf = new jsPDF({
      orientation: "p",
      unit: "pt",
      format: "a3",
    });
    pdf.html(htmlString, {
      callback: function (pdf) {
        let filename = `order-invoice-${props.order.order_barcode}.pdf`;
        pdf.save(filename);
      },
    });
  };
  return (
    <React.Fragment>
      <Tooltip title="Download Invoice">
        <Button
          onClick={print}
          variant="contained"
          color="default"
          className={classes.button}
          startIcon={<GetAppRoundedIcon />}
        >
          Download Invoice
        </Button>
      </Tooltip>
    </React.Fragment>
  );
};
export default GeneratePdf;
